import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../../../providers';
import { SubscriptionStrings } from '../../../../business/core';

export const SubscriptionStatementFree: React.FC = () => {
    const navigate = useNavigate();
    const { userData } = useAuth();

    const translate = SubscriptionStrings['PTBR'].page.plans.Free.upgrade;

    const handleUpgradeClick = (e: React.MouseEvent) => {
        navigate("/subscription");
    };

    return (
        <>
            <p>{translate.text}</p>
            <Button onClick={handleUpgradeClick}>{translate.button_label}</Button>
        </>
    );
};